{% block sw_cms_block_jga_revocation_button_preview %}
<div style="text-align: center; padding: 15px;">
    <div style="display: inline-block; background: #0870e0; color: white; padding: 10px 24px; border-radius: 4px; font-size: 14px; font-weight: 600;">
        {{ $tc('jga-revocation.cms.previewLabel') }}
    </div>
</div>
{% endblock %}
